import wabysLogo from "../../assets/wabys.png";
import person from "../../assets/person.jpg";
import { useEffect, useState } from "react";
import { wisdomFetchCROData } from "services/dashboard";

const CroReport2 = ({ pdfRef2, selectedOrgId, selectedMonthIdx }) => {
    const [croData, setCroData] = useState([]);
    const [sortedCroData, setSortedCroData] = useState([]);

    // fetch wisdom dashboard data
    useEffect(() => {
        const loadData = async () => {
            const response = await wisdomFetchCROData();

            setCroData(response);
        };

        loadData();
    }, []);

    // arrange and filter CRO data
    useEffect(() => {
        const arrangeCro = () => {
            const arrangeData = croData.map(item => {
                const months = item.months || [];
                return months[months.length - 1];
            });
            const sortedData = combineAllReports(arrangeData)
            setSortedCroData(sortedData)
        };

        arrangeCro();
    }, [croData]);

    useEffect(() => {
        const filterCROData = async () => {
            if (!croData || croData.length === 0) return; // data not ready

            if (selectedOrgId !== "All") {
                const result = croData.find(obj => obj.id === selectedOrgId);

                if (!result || !result.months) {
                    console.warn("No matching org or months data found for:", selectedOrgId);
                    setSortedCroData([]);
                    return;
                }

                const monthData = result.months[selectedMonthIdx] || result.months.at(-1);
                const sortedData = combineAllReports([monthData]);
                setSortedCroData(sortedData);
            } else {
                const arrangeData = croData.map(item => {
                    const months = item.months || [];
                    return months[months.length - 1];
                });
                const sortedData = combineAllReports(arrangeData);
                setSortedCroData(sortedData);
            }
        };

        filterCROData();
    }, [selectedMonthIdx, selectedOrgId, croData]);

    const combineAllReports = (data) => {
        const grouped = {};

        data.forEach((monthData) => {
            monthData?.reports?.forEach((report) => {
                report.scores.forEach((score) => {
                    const rec = score.recommendation;
                    const field = score.field_name;

                    // Create recommendation group if not exists
                    if (!grouped[rec]) grouped[rec] = {};

                    // Create field group if not exists
                    if (!grouped[rec][field]) grouped[rec][field] = [];

                    // Add score info
                    grouped[rec][field].push({
                        name: report.name,
                        subject: report.subject,
                        authority: report.authority,
                        avg_score: score.avg_score,
                        field_id: score.field_id,
                    });
                });
            });
        });

        return grouped;
    };

    return (
        <div className="w-full flex flex-col items-center" ref={pdfRef2}>
            {Object.entries(sortedCroData).map(([key, value]) => (
                <div className="bg-white w-[40%] max-w-5xl h-fit p-4 flex flex-col items-center mt-4 text-black rounded-lg shadow-lg">
                    {/* Header */}
                    <div className="flex justify-between items-center w-full max-w-4xl mb-2">
                        {/* Left logos */}
                        <div className="flex flex-col items-center w-14">
                            <img src={wabysLogo} className="w-14" alt="Ebda Edu logo" />
                        </div>

                        {/* Center title */}
                        <div className="flex flex-col items-center gap-2 text-xs font-bold text-center">
                            <h1 className="border-b-2 border-black text-black">تقرير توصيات توجيه مؤشر الاداء</h1>
                            <h1 className="border-b-2 border-black text-black">لتنمية الجوانب المهنية - ( {key} )</h1>
                        </div>

                        {/* Right logo */}
                        <div className="flex flex-col">
                            <img src={wabysLogo} className="w-14" alt="Wabys logo" />
                        </div>
                    </div>

                    {/* Reports */}
                    {Object.entries(value).map(([key, value2]) => (
                        <div key={key} className="w-full max-w-4xl rounded-xl shadow mt-2 border border-gray-300 bg-white">
                            <h1 className="flex justify-between gap-2 text-end pr-4 font-bold text-sm mt-2 mb-1 px-1"><p>عدد المعلمين : {value2.length}</p> <p>: {key}</p></h1>
                            <div className="w-full border-t border-gray-300 p-2">
                                <table className="w-full border-collapse text-center">
                                    <thead className="bg-gray-100">
                                        <tr className="border-b border-black">
                                            <th className="w-2/12 py-2">النسبة</th>
                                            <th className="w-2/12 py-2">التخصص</th>
                                            <th className="w-2/12 py-2">المدرسة</th>
                                            <th className="w-3/12 py-2">الاسم</th>
                                            <th className="w-2/12 py-2">الصورة</th>
                                            <th className="w-1/12 py-2">م</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {value2.map((result, idx) => (
                                            <tr className="border-b last:border-0 hover:bg-gray-50">
                                                <td className="py-2 font-bold text-sm">{result.avg_score}%</td>
                                                <td className="py-2 text-xs font-medium text-center">{result.subject}</td>
                                                <td className="py-2 text-xs font-medium text-center">{result.authority}</td>
                                                <td className="py-2 text-xs font-medium text-center">{result.name}</td>
                                                <td className="py-2 text-xs font-medium text-center">
                                                    <img src={person} alt="" className="w-10 h-10 object-cover rounded-full mx-auto" />
                                                </td>
                                                <td className="py-2 text-xs font-medium text-center">{idx + 1}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}
                </div>))}
        </div>
    )
};

export default CroReport2;